// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"c9712051","63":"fb2eee77","305":"4fb99624","835":"000e9a08","892":"3a289265","933":"a2321b5b"}[chunkId] + ".chunk.css";
};